import { TIdToPageConfigMap } from 'models/common.model'
import { HeaderId } from 'nove8/constants/root-constants'
import { PageIdStylioPlus } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_STYLIO_PLUS: TIdToPageConfigMap = {
  [PageIdStylioPlus.AGE_STYLIO_PLUS]: {
    id: PageIdStylioPlus.AGE_STYLIO_PLUS,
    hasHeader: true,
    progressBar: 'controlled',
    progressBarHidden: true,
  },
  [PageIdStylioPlus.URGE_STYLIO_PLUS]: {
    id: PageIdStylioPlus.URGE_STYLIO_PLUS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioPlus.HAIR_COLOR_STYLIO_PLUS]: {
    id: PageIdStylioPlus.HAIR_COLOR_STYLIO_PLUS,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioPlus.EYES_COLOR_STYLIO_PLUS]: {
    id: PageIdStylioPlus.EYES_COLOR_STYLIO_PLUS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioPlus.JEWELRY_STYLIO_PLUS]: {
    id: PageIdStylioPlus.JEWELRY_STYLIO_PLUS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioPlus.BODY_SHAPE_STYLIO_PLUS]: {
    id: PageIdStylioPlus.BODY_SHAPE_STYLIO_PLUS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioPlus.STYLIO_TO_HELP_STYLIO_PLUS]: {
    id: PageIdStylioPlus.STYLIO_TO_HELP_STYLIO_PLUS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioPlus.TALL_STYLIO_PLUS]: {
    id: PageIdStylioPlus.TALL_STYLIO_PLUS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioPlus.WEIGHT_STYLIO_PLUS]: {
    id: PageIdStylioPlus.WEIGHT_STYLIO_PLUS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioPlus.HIGHLIGHT_LOOK_STYLIO_PLUS]: {
    id: PageIdStylioPlus.HIGHLIGHT_LOOK_STYLIO_PLUS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioPlus.CLOTHES_FIT_STYLIO_PLUS]: {
    id: PageIdStylioPlus.CLOTHES_FIT_STYLIO_PLUS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioPlus.URGE_2_STYLIO_PLUS]: {
    id: PageIdStylioPlus.URGE_2_STYLIO_PLUS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioPlus.SHOPPING_STYLIO_PLUS]: {
    id: PageIdStylioPlus.SHOPPING_STYLIO_PLUS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioPlus.STYLE_MOST_MATTERS_STYLIO_PLUS]: {
    id: PageIdStylioPlus.STYLE_MOST_MATTERS_STYLIO_PLUS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioPlus.FAVORITE_COLORS_STYLIO_PLUS]: {
    id: PageIdStylioPlus.FAVORITE_COLORS_STYLIO_PLUS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioPlus.LIKE_OR_DISLIKE_STYLIO_PLUS]: {
    id: PageIdStylioPlus.LIKE_OR_DISLIKE_STYLIO_PLUS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioPlus.LIKE_OR_DISLIKE_11_STYLIO_PLUS]: {
    id: PageIdStylioPlus.LIKE_OR_DISLIKE_11_STYLIO_PLUS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioPlus.LIKE_OR_DISLIKE_12_STYLIO_PLUS]: {
    id: PageIdStylioPlus.LIKE_OR_DISLIKE_12_STYLIO_PLUS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioPlus.LIKE_OR_DISLIKE_13_STYLIO_PLUS]: {
    id: PageIdStylioPlus.LIKE_OR_DISLIKE_13_STYLIO_PLUS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioPlus.LIKE_OR_DISLIKE_14_STYLIO_PLUS]: {
    id: PageIdStylioPlus.LIKE_OR_DISLIKE_14_STYLIO_PLUS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioPlus.LIKE_OR_DISLIKE_15_STYLIO_PLUS]: {
    id: PageIdStylioPlus.LIKE_OR_DISLIKE_15_STYLIO_PLUS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioPlus.LIKE_OR_DISLIKE_16_STYLIO_PLUS]: {
    id: PageIdStylioPlus.LIKE_OR_DISLIKE_16_STYLIO_PLUS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioPlus.LIKE_OR_DISLIKE_17_STYLIO_PLUS]: {
    id: PageIdStylioPlus.LIKE_OR_DISLIKE_17_STYLIO_PLUS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioPlus.STYLES_FEEL_LIKE_YOU_STYLIO_PLUS]: {
    id: PageIdStylioPlus.STYLES_FEEL_LIKE_YOU_STYLIO_PLUS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioPlus.URGE_4_STYLIO_PLUS]: {
    id: PageIdStylioPlus.URGE_4_STYLIO_PLUS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioPlus.BRAND_STYLIO_PLUS]: {
    id: PageIdStylioPlus.BRAND_STYLIO_PLUS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioPlus.FIND_NEW_CLOTHES_STYLIO_PLUS]: {
    id: PageIdStylioPlus.FIND_NEW_CLOTHES_STYLIO_PLUS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioPlus.NOTHING_TO_WEAR_STYLIO_PLUS]: {
    id: PageIdStylioPlus.NOTHING_TO_WEAR_STYLIO_PLUS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioPlus.OLD_CLOTHES_STYLIO_PLUS]: {
    id: PageIdStylioPlus.OLD_CLOTHES_STYLIO_PLUS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioPlus.COMBINE_CLOTHES_STYLIO_PLUS]: {
    id: PageIdStylioPlus.COMBINE_CLOTHES_STYLIO_PLUS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioPlus.OPTIMIZE_BUDGET_STYLIO_PLUS]: {
    id: PageIdStylioPlus.OPTIMIZE_BUDGET_STYLIO_PLUS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioPlus.URGE_3_STYLIO_PLUS]: {
    id: PageIdStylioPlus.URGE_3_STYLIO_PLUS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioPlus.PREPARE_FLOW_STYLIO_PLUS]: {
    id: PageIdStylioPlus.PREPARE_FLOW_STYLIO_PLUS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioPlus.EMAIL_STYLIO_PLUS]: {
    id: PageIdStylioPlus.EMAIL_STYLIO_PLUS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioPlus.EMAIL_CONSENT_STYLIO_PLUS]: {
    id: PageIdStylioPlus.EMAIL_CONSENT_STYLIO_PLUS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioPlus.SUBSCRIPTIONS_STYLIO_PLUS]: {
    id: PageIdStylioPlus.SUBSCRIPTIONS_STYLIO_PLUS,
    hasHeader: true,
  },
  [PageIdStylioPlus.CANCEL_OFFER_STYLIO_PLUS]: {
    id: PageIdStylioPlus.CANCEL_OFFER_STYLIO_PLUS,
    hasHeader: true,
  },
  [PageIdStylioPlus.SUB_UPSELL_STYLIO_PLUS]: {
    id: PageIdStylioPlus.SUB_UPSELL_STYLIO_PLUS,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioPlus.UPSELL_STYLIO_PLUS]: {
    id: PageIdStylioPlus.UPSELL_STYLIO_PLUS,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioPlus.NAME_STYLIO_PLUS]: {
    id: PageIdStylioPlus.NAME_STYLIO_PLUS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioPlus.LAST_CHANCE_OFFER_STYLIO_PLUS]: {
    id: PageIdStylioPlus.LAST_CHANCE_OFFER_STYLIO_PLUS,
  },
  [PageIdStylioPlus.DOWNLOAD_STYLIO_PLUS]: {
    id: PageIdStylioPlus.DOWNLOAD_STYLIO_PLUS,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
}
